import axios from 'axios'

const service = axios.create({
    baseURL: 'http://127.0.0.1:5000/',
    timeout: 60000,
    headers: {
        'Content-type': 'application/json',
    },
})
// service.interceptors.request.use(
//     (config) => {
//         if (localStorage.userToken) {
//             config.headers.Authorization = `Bearer ${localStorage.userToken}`
//         }
//     },
// )
export default service
